import * as React from 'react'

export const SEARCH_MATCH_HIGHLIGHT_CLASS = 'search-match-highlight'

export function highlightSearchMatch(text: string, query: string): React.ReactNode {
  const trimmedQuery = query.trim()
  if (!trimmedQuery) return text

  const lowerText = text.toLowerCase()
  const lowerQuery = trimmedQuery.toLowerCase()
  const parts: React.ReactNode[] = []
  let start = 0

  while (start < text.length) {
    const matchIndex = lowerText.indexOf(lowerQuery, start)
    if (matchIndex === -1) {
      parts.push(text.slice(start))
      break
    }
    if (matchIndex > start) {
      parts.push(text.slice(start, matchIndex))
    }
    parts.push(
      <mark key={matchIndex} className={SEARCH_MATCH_HIGHLIGHT_CLASS}>
        {text.slice(matchIndex, matchIndex + trimmedQuery.length)}
      </mark>
    )
    start = matchIndex + trimmedQuery.length
  }

  return parts.length === 1 ? parts[0] : parts
}
